import { __decorate, __metadata } from "tslib";
import ListOperationServLock from '@/presentation/pages/detail/basic/interface_lock/ListOperationServLock';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { CopyMoveViewDataServiceSymbol } from '@/presentation/pages/detail/basic/service/CopyMoveViewDataService';
import { useRefreshWithParams } from '@/presentation/pages/detail/basic/hooks/useRefreshWithParams';
import { useRemoveViewDataConfirm } from '@/presentation/pages/detail/basic/hooks/useRemoveViewDataConfirm';
import { useUpdateReadStatus } from '@/presentation/pages/detail/basic/hooks/useUpdateReadStatus';
import { injectable } from 'inversify';
import { injectService } from '@patsnap/tahiti-core';
let PaperListOperationService = class PaperListOperationService extends ListOperationServLock {
    get pageSelectorService() {
        return this._pageSelectorService;
    }
    constructor() {
        super();
        this._pageSelectorService = injectService(PageSelectorServiceSymbol);
        this.copyMoveViewDataService = injectService(CopyMoveViewDataServiceSymbol);
    }
    onUnselectAll() {
        throw new Error('onUnselect is not implemented');
    }
    onExport() {
        throw new Error('onExport is not implemented');
    }
    get selectedCount() {
        return this._pageSelectorService.selectedCount;
    }
    async startTargetFolderSelection(mode) {
        return this.copyMoveViewDataService.open({ mode, selectedCount: this.selectedCount });
    }
    async onCopy() {
        const target = await this.startTargetFolderSelection('copy');
        await this.copyMoveViewDataService.makeChange({
            spaceId: this.spaceId,
            folderId: this.folderId,
            ...target,
        });
    }
    async onMove() {
        const target = await this.startTargetFolderSelection('move');
        await this.copyMoveViewDataService.makeChange({
            spaceId: this.spaceId,
            folderId: this.folderId,
            ...target,
        });
        useRefreshWithParams();
        this._pageSelectorService.unselectAll();
    }
    onDelete() {
        const { state } = useRemoveViewDataConfirm();
        return state.then(success => {
            if (success) {
                this.onUnselectAll();
                useRefreshWithParams();
            }
        });
    }
    onSetReadStatus(type) {
        const { updateReadStatus } = useUpdateReadStatus();
        return updateReadStatus(type).then(data => {
            data && data.async && useRefreshWithParams();
        });
    }
};
PaperListOperationService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], PaperListOperationService);
export default PaperListOperationService;
